import { USER_JOURNEY_TIMEOUT_LATE_FIRE_GRACE_MS, USER_JOURNEY_TIMEOUT_MS } from './constants'
import { JourneyOutcome, JourneyTerminationReason } from './types'

export const getExpiredJourneyTimeoutTerminationReason = (startedAtEpochMs: number | undefined): JourneyTerminationReason | undefined => {
  if (startedAtEpochMs === undefined) {
    return undefined
  }
  const deadline = startedAtEpochMs + USER_JOURNEY_TIMEOUT_MS
  if (Date.now() < deadline) {
    return undefined
  }
  return Date.now() - deadline > USER_JOURNEY_TIMEOUT_LATE_FIRE_GRACE_MS || document.visibilityState === 'hidden'
    ? JourneyTerminationReason.TIMEOUT_WITH_IDLE_USER
    : JourneyTerminationReason.TIMEOUT_WITH_ACTIVE_USER
}

export const getReplacedJourneyCompletion = (
  startedAtEpochMs: number
):
  | { outcome: JourneyOutcome.PROCESS_KILLED; terminationReason?: undefined }
  | { outcome: JourneyOutcome.TERMINATED; terminationReason: JourneyTerminationReason.TIMEOUT_WITH_IDLE_USER } =>
  Date.now() - startedAtEpochMs > USER_JOURNEY_TIMEOUT_MS
    ? { outcome: JourneyOutcome.TERMINATED, terminationReason: JourneyTerminationReason.TIMEOUT_WITH_IDLE_USER }
    : { outcome: JourneyOutcome.PROCESS_KILLED }
